import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, ref, defineModel } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect,
  BaseInput
} from 'xrk-components';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import {
  invoiceCategory,
  selectParkList
} from '@V/invoice/src/data-source/apis';
import { taxPatternMapping } from '@constants/project';
import { INVOICE_TYPE } from '@V/invoice/src/constants';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-individual-dialog-content',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const formData = _useModel<FormData>(__props, "modelValue");
const formRef = ref(null);

const formRules = {
  theSellerId: [{ required: true, message: '请选择', trigger: 'change' }],
  itemId: [{ required: true, message: '请选择', trigger: 'change' }],
  taxPattern: [{ required: true, message: '请选择', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }]
};

const gthRemote = keyWord => {
  return selectParkList({
    keyWord,
    pageNum: 1,
    pageSize: 200,
    loginUserId: userInfo.value.loginUserId,
    functionCode: userInfo.value.functionCode
  });
};
const itemIdRemote = () => {
  return invoiceCategory({
    stateType: 7, // 写死7 formData.value.stateType,
    invoiceType: formData.value.invoiceType,
    theSellerId: formData.value.theSellerId
  });
};

const onGthChange = (val, [option]) => {
  formData.value.itemId = null;
  formData.value.entpCertNo = option.entpCertNo;
};
const onInvoiceTypeChange = () => {
  formData.value.itemId = null;
};
__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "right",
    scrollToError: "",
    model: formData.value,
    rules: formRules,
    "column-count": 2
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseFormItem), {
        label: "个体户名称",
        prop: "theSellerId"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseSelect), {
            class: "form-dialog__w280",
            placeholder: "请选择",
            "label-key": "individualName",
            "value-key": "individualId",
            init: false,
            remoteMethod: gthRemote,
            modelValue: formData.value.theSellerId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.theSellerId) = $event)),
            onChange: onGthChange
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: "统一社会信用代码",
        prop: "entpCertNo"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseInput), {
            class: "form-dialog__w280",
            placeholder: "请填写",
            modelValue: formData.value.entpCertNo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.entpCertNo) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: "发票类型",
        prop: "invoiceType"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseSelect), {
            class: "form-dialog__w280",
            type: "text",
            placeholder: "请输入",
            modelValue: formData.value.invoiceType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.invoiceType) = $event)),
            options: _unref(INVOICE_TYPE),
            onChange: onInvoiceTypeChange
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: "开票类目",
        prop: "itemId"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseSelect), {
            class: "form-dialog__w280",
            type: "text",
            placeholder: "请选择",
            "label-key": "itemName",
            "value-key": "id",
            disabled: !formData.value.theSellerId || !formData.value.invoiceType || _ctx.disabled,
            init: false,
            remoteMethod: itemIdRemote,
            modelValue: formData.value.itemId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.itemId) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: "交易结构",
        prop: "taxPattern"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseSelect), {
            class: "form-dialog__w280",
            type: "text",
            placeholder: "请选择",
            modelValue: formData.value.taxPattern,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.taxPattern) = $event)),
            options: [_unref(taxPatternMapping)[5]]
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseFormItem), {
        label: "选择日期",
        prop: "receiveAt"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseDatePicker), {
            class: "form-dialog__w280",
            style: {"width":"280px"},
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            type: "daterange",
            modelValue: formData.value.receiveAt,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.receiveAt) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})